<ng-container *ngFor="let card of onecards ">
  <app-centercard [card]="card"></app-centercard>
</ng-container>
